import styled, { css } from 'styled-components';

export const ConfirmationToken = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.xl};
    font-family: ${theme.v3.font.family.brand};
    padding: 24px;
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px 0;
    width: 100%;
    max-width: 510px;
    padding: 24px 0;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      gap: 16px;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    text-align: center;
    margin: 0;
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;    
  `}
`;

export const InputWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    width: 100%;

    span {
      font-size: ${theme.v3.font.sizes.mini};
      font-weight: ${theme.v3.font.weights.medium};
      line-height: ${theme.v3.font.lineHeight.compact};
      color: ${theme.v3.colors.neutral[60]};
      padding: 8px 0 0 16px;
    }
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      gap: 12px;
    }
  `}
`;

export const ModalContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const ModalContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 40px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 24px;
    }
  `}
`;

export const ModalDescription = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
  `}
`;

export const ModalActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      gap: 12px;
    }
  `}
`;
